import React, { useContext, forwardRef, useState } from "react";
import DrawerContext from "../../context/drawer/drawerContext";
import { ControlPanelCss } from "./ControlPanelCss";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import gql from "graphql-tag";
import { useSnackbar } from "notistack";
import { useQuery, useMutation } from "@apollo/react-hooks";



import
{
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Slide,
    Container,
    useTheme,
    Dialog,
    Paper,
    FormControl,
    OutlinedInput,
    InputLabel,
    InputAdornment,
    Button
} from "@material-ui/core";
import { Visibility, VisibilityOff } from '@material-ui/icons'

import clsx from 'clsx';






const GQL_CHANGE_PASSWORD = gql`

mutation ($username:String, $newpassword:String, $confirmpassword:String){
    changePassword(userName:$username, newPassword:$newpassword, confirmPassword:$confirmpassword) {
      _id
      userName
      password
      role
      token
    }
  }

`




const Transition = forwardRef(function Transition(props, ref)
{
    return <Slide direction="up" ref={ref} {...props} />;
});


const ControlPanel = () =>
{
    const drawerContext = useContext(DrawerContext);
    const handleClose = () =>
    {
        drawerContext.handleControlPanel();
    };
    const classes = ControlPanelCss();


    const [user, setUser] = useState({

        userName: "",
        newPassword: "",
        confirmPassword: "",
        showPassword: false,



    })
    const { enqueueSnackbar } = useSnackbar();
    const changeInput = (type) => (event) =>
    {
        setUser({ ...user, [type]: event.target.value })
    }
    const handleClickShowPassword = () =>
    {

        setUser({ ...user, showPassword: !user.showPassword })
    }
    const showMessage = (msg, variant) =>
    {
        let time = 1000;
        if (variant === "error") time = 3000;
        enqueueSnackbar(msg, { variant, autoHideDuration: time });
    };

    const [changePassword] = useMutation(GQL_CHANGE_PASSWORD);
    return (
        <Dialog
            fullScreen
            open={drawerContext.control}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Control Panel
          </Typography>
                </Toolbar>
            </AppBar>
            <Container maxWidth="lg">
                <Paper elevation={3} className={classes.paper} >
                    <form noValidate >
                        <FormControl variant="outlined" className={clsx(classes.centerElements, classes.input)}  >
                            <InputLabel> User Name</InputLabel>
                            <OutlinedInput
                                id="oldPassword"
                                type="text"
                                value={user.userName}
                                onChange={changeInput('userName')}
                                labelWidth={150}

                            />
                        </FormControl>

                        <FormControl variant="outlined" className={clsx(classes.centerElements, classes.input)} >
                            <InputLabel htmlFor="newPassword">New Password</InputLabel>
                            <OutlinedInput
                                id="newPassword"
                                type={user.showPassword ? "text" : "password"}
                                onChange={changeInput('newPassword')}
                                labelWidth={150}
                                value={user.newPassword}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {user.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        <FormControl variant="outlined" className={clsx(classes.centerElements, classes.input)} >
                            <InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
                            <OutlinedInput
                                id="confirmPassword"
                                type={user.showPassword ? "text" : "password"}
                                onChange={changeInput('confirmPassword')}
                                labelWidth={150}
                                value={user.confirmPassword}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {user.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <div className={clsx(classes.centerElements)} >
                            <Button className={classes.btnLogin}
                                fullWidth variant="contained"
                                size="large" color="primary"
                                onClick={async () =>
                                {

                                    try
                                    {
                                        await changePassword({
                                            variables: {
                                                username: user.userName,
                                                newpassword: user.newPassword,
                                                confirmpassword :user.confirmPassword

                                            }
                                        })

                                        showMessage('success', 'success')
                                    }
                                    catch (error)
                                    {
                                        showMessage(error.message, 'error')
                                    }

                                }}
                            >
                                Change Password
                        </Button>
                        </div>

                    </form>
                </Paper>

            </Container>
        </Dialog>
    );
};

export default ControlPanel;
